export default "__VITE_ASSET__8463d827__"